import { render } from "./BuyAndSell.vue?vue&type=template&id=0218a1c9"
import script from "./BuyAndSell.vue?vue&type=script&lang=js"
export * from "./BuyAndSell.vue?vue&type=script&lang=js"

import exportComponent from "/Users/anderson/Developer/Landing-Page/iCoin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__